import "./line.scss";

export default function Line() {
  return <div className={'line'}/>;
}
